import { useQuery } from '@apollo/client/react';
import { isRiskIqEnabled } from '@utils-clean/feature-flags';
import { ProtocolInsightsApp, RiskIQAccess } from 'types/graphql-global-types';
import { GET_PROTOCOL_INSIGHTS_ACCESS } from '@queries/protocol-insights';

// The current user's effective access to a Protocol Insights app for a study, as calculated by OPRA Core
// (Trial.OS study team level, system admin rules, RAM module and read-only study). ADO 90806.
export const useProtocolInsightsAccess = (
    app: ProtocolInsightsApp,
    studyId: string | null | undefined,
): { access: RiskIQAccess | undefined; loading: boolean } => {
    const { data, loading } = useQuery(GET_PROTOCOL_INSIGHTS_ACCESS, {
        variables: { studyId: studyId ?? '', app },
        // Protocol Insights is hidden while the RiskIQ flag is off, so the nav must not ask (or depend on Core having
        // this query) for every user.
        skip: !studyId || !isRiskIqEnabled(),
        fetchPolicy: 'cache-and-network',
    });

    return { access: data?.protocolInsightsAccess, loading };
};
